module.exports = __webpack_public_path__ + "img/enclosure.930fc790.png";